import React from 'react'

export default function Modal ({ isOpen, onClose, title, children, footer, width = 1040 }) {
  if (!isOpen) return null

  return (
    <div className='ui-modal-overlay' onClick={onClose}>
      <div className='ui-modal' style={{ width: `min(${width}px, 100%)` }} onClick={e => e.stopPropagation()}>
        <div className='ui-modal-header'>
          <h5>{title}</h5>
          <button type='button' className='ui-modal-close' onClick={onClose}>
            &times;
          </button>
        </div>
        <div className='ui-modal-body'>
          {children}
        </div>
        {footer && (
          <div className='ui-modal-footer'>
            {footer}
          </div>
        )}
      </div>
    </div>
  )
}
